import { LendingDto } from '@core/services/dto';


export class LoanModel {
  accountNumber: string;
  accountBalance: number;
  availableBalance: number;
  outstandingBalance: number;
  paymentFrequency: string;
  paymentAmount: number | string;
  dueDate: string;
  currentArrears: string | number;
  overdueDays: number;
  status: string;
  subType: string;
  type: string;
  branch: string;
  openedDate: string;
  ownershipType: string;
  purpose: string;
  maturityDate: string;
  revolving: string;
  riskRating: string;
  termLength: string;
  termRemaining: string;
  termStartDate: string;
  name: string;

  constructor(dto: LendingDto) {


    this.accountNumber = dto.accountNumber;
    this.accountBalance = dto.accountBalance || 0;
    this.availableBalance = dto.availableBalance || 0;
    this.outstandingBalance = dto.outstandingBalance || 0;
    this.paymentFrequency = dto.paymentFrequency;
    this.paymentAmount = dto.paymentAmount || 0;

    this.dueDate = dto.dueDate;
    this.currentArrears = dto.currentArrears || 0;
    this.overdueDays = dto.overdueDays;
    this.status = dto.status;
    this.type = dto.type;
    this.subType = dto.subType;
    this.branch = dto.branch;
    this.openedDate = dto.openedDate;
    this.ownershipType = dto.ownershipType;
    this.purpose = dto.purpose;
    this.maturityDate = dto.maturityDate;
    this.revolving = dto.revolving ? 'Yes' : 'No';
    this.riskRating = dto.riskRating;
    this.termLength = (dto.term?.termLength && dto.term?.termLengthType) ?
      `${dto.term.termLength} ${dto.term.termLengthType}` : '';
    this.termRemaining = (dto.term?.termRemainingLength && dto.term?.termRemainingLengthType) ?
      `${dto.term.termRemainingLength} ${dto.term.termRemainingLengthType}` : '';
    this.termStartDate = dto.term?.termStartDate;
    this.name = dto.name || 'Lending';
  }
}
